import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useState } from 'react';
import { Col, Container, OverlayTrigger, Popover, Row } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/esm/types';
import { Link } from 'react-router-dom';
import Button from '../../../components/Button';
import Notification from '../../../components/Notification';
import { ACTIONS_ROUTE } from '../../../routes/types';
import { getAllNotifications } from '../../../services/notifications';
import {
  addOrRemoveDaysToGivenDate,
  DateFormats,
  formatDate,
} from '../../../utils/utils';

export type NotificationPopUpProps = React.PropsWithChildren<{
  placement?: Placement;
}>;

const NotificationPopUp = ({ placement, children }: NotificationPopUpProps) => {
  const notifications = getAllNotifications().reverse();

  const latestNotifications = notifications
    .filter((notification, idx) => idx < 3)
    .map((notification) => {
      const newDate = addOrRemoveDaysToGivenDate(new Date(), 25);
      notification.date = formatDate(
        newDate,
        DateFormats.SHORT_MONTH_DAY_YEAR
      ) as string;

      return notification;
    });

  const removed = latestNotifications.splice(1, 1);
  const [notificationList, setIsReadPopUp] = useState(latestNotifications);

  const [show, setShow] = useState(false);
  const handleShow = () => {
    setShow((prev) => !prev);
  };

  const handleIsReadDefault = (idx: number) => {
    return;
    if (!notificationList[idx].isRead) {
      const newNotificationObj = [...notificationList];
      newNotificationObj[idx].isRead = true;
      const unreadNotifications = newNotificationObj.filter((x) => !x.isRead);

      setIsReadPopUp((prev) => (prev = unreadNotifications));
    }
  };

  const noNotificationsPopUpBody = (
    <Row className={'my-13 '}>
      <Col className={'text-center col-12'}>
        <img
          src={`${process.env.PUBLIC_URL}/no-notifications.png`}
          alt={'no-notifications'}
        />
      </Col>
      <Col className={'col-12 text-center'}>
        <h2 className={'text-sm-20-lg-24 fw-light'}>No notifications yet</h2>
      </Col>
      <Col className={'col-12 text-center'}>
        <span className={'text-fs-6 fw-light'}>
          Stay tuned! Notifications about your activity will show up here.
        </span>
      </Col>
    </Row>
  );

  const notificationPopUpBody = (
    <Popover bsPrefix={'popover pop-up'} className={'z-index-1049'}>
      <Popover.Body>
        <Button
          onClick={handleShow}
          rightIcon={light('close')}
          className={'px-0 close-btn position-absolute'}
        ></Button>
        <Row className={'pop-up-row-wrapper'}>
          <Col className={'mb-11'}>
            <h5>Actions</h5>
          </Col>
          <Col className={'col-12'}>
            <Container
              className={'px-0 pb-4 mw-100 border-bottom-light-gray-lg'}
            >
              <span
                className={
                  'position-relative px-4 pb-4 text-blue fw-normal required-action'
                }
              >
                Required Actions
                <span
                  className={
                    'ms-3 px-3 text-caption text-white notification-counter'
                  }
                >
                  {notificationList.length}
                </span>
              </span>
            </Container>
          </Col>
        </Row>
        {notificationList.length === 0 ? (
          noNotificationsPopUpBody
        ) : (
          <>
            <Row className={'pop-up-row-wrapper'}>
              {notificationList.map((notification, idx) => {
                return (
                  <Col key={idx} className={'col-12'}>
                    <Notification
                      variant={'pop-up'}
                      notificationData={notification}
                      onClick={() => handleIsReadDefault(idx)}
                    />
                  </Col>
                );
              })}
            </Row>
            <Row>
              <Col className={'text-center mt-10'}>
                <Link
                  onClick={handleShow}
                  className={'text-decoration-none'}
                  to={ACTIONS_ROUTE}
                >
                  View All Actions
                </Link>
              </Col>
            </Row>
          </>
        )}
      </Popover.Body>
    </Popover>
  );
  return (
    <OverlayTrigger
      overlay={notificationPopUpBody}
      trigger={'click'}
      show={show}
      placement={placement}
      onToggle={handleShow}
      rootClose={show}
    >
      <Container>{children}</Container>
    </OverlayTrigger>
  );
};

export default NotificationPopUp;
